<template>
  <div>
    <a-modal
      v-model="visible"
      :title="action === 'Create' ? 'Tambah ' : 'Edit ' + ' Role Permission'"
      :dialogStyle="{ top: '10px' }"
      :destroyOnClose="true"
      :forceRender="true"
    >
      <template slot="footer">
        <a-button class="btn btn-outline-danger" @click="handleCancel">
          Cancel
        </a-button>
        <a-button
          class="btn btn-outline-primary"
          :loading="loading"
          @click="submit()"
        >
          Simpan
        </a-button>
      </template>
      <div class="row">
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Instansi</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-select
            class=""
            style="width: 100%;"
            show-search
            placeholder="Pilih Instansi"
            option-filter-prop="children"
            v-model="input.instansi_id"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="(data, index) in datainstansi"
              :value="data.id"
              :key="index"
            >
              {{ data.keterangan }}
            </a-select-option>
          </a-select>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">NIP</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-input class="" v-model="input.nip"></a-input>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">NIK</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-input class="" v-model="input.nik"></a-input>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Nama</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-input class="" v-model="input.nama"></a-input>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Kelamin</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-select
            class=""
            style="width: 100%;"
            show-search
            placeholder="Pilih Kelamin"
            option-filter-prop="children"
            v-model="input.kelamin"
            :filter-option="filterOption"
          >
            <a-select-option
              value="L"
            >
              Laki - Laki
            </a-select-option>
            <a-select-option
              value="P"
            >
              Perempuan
            </a-select-option>
          </a-select>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Tempat Lahir</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-input class="" v-model="input.tempat_lahir"></a-input>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Tanggal Lahir</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-date-picker ref="input" format="DD-MM-YYYY" :allowClear="false" v-model="inputdate" @change="onDateChanged"/>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Alamat</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-input class="" v-model="input.alamat"></a-input>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Status Nikah</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-select
            class=""
            style="width: 100%;"
            show-search
            placeholder="Pilih Status Nikah"
            option-filter-prop="children"
            v-model="input.status_nikah"
            :filter-option="filterOption"
          >
            <a-select-option
              value="B"
            >
              Belum Menikah
            </a-select-option>
            <a-select-option
              value="S"
            >
              Sudah Menikah
            </a-select-option>
          </a-select>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 mb-2">
          <label class="mt-1">Golongan</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-9 mb-2">
          <a-select
            class=""
            style="width: 100%;"
            show-search
            placeholder="Pilih Golongan"
            option-filter-prop="children"
            v-model="input.golongan_id"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="(data, index) in datagolongan"
              :value="data.id"
              :key="index"
            >
              {{ data.keterangan }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as lou from '@/services/data/lou'
import moment from 'moment'
// import Cleave from 'vue-cleave-component'

export default {
  components: {
    // cleave: Cleave,
  },
  data() {
    return {
      action: 'Create',
      editdata: [],
      input: {
        instansi_id: '',
        nip: '',
        nik: '',
        nama: '',
        kelamin: '',
        tempat_lahir: '',
        tgl_lahir: moment().format('YYYY-MM-DD'),
        alamat: '',
        status_nikah: '',
        golongan_id: '',
      },
      inputdate: moment(),
      editshiftmode: false,
      datatable: [],
      dataSource: [],
      datainstansi: [],
      datagolongan: [],
      dataroletype: [],
      visible: false,
      loading: false,
      datenow: '',
    }
  },
  created() {
    this.datenow = lou.datenow()
  },
  methods: {
    moment,
    onDateChanged(a, b) {
      // console.log('a', a)
      // console.log('b', b)
      // console.log('this.inputdate', this.inputdate)
      this.input.tgl_lahir = a.format('YYYY-MM-DD')
    },
    inputChange(e) {
      // console.log('e', e)
    },
    async submit() {
      this.loading = true
      var fd = this.input
      if (this.action === 'Create') {
        await lou.customUrlPost('gaji/pegawai', fd, true, true)
      } else {
        fd.id = this.editdata.id
        fd.bpr_id = this.editdata.bpr_id
        await lou.customUrlPut('gaji/pegawai', fd, true, true)
      }
      this.loading = false
      this.$parent.getData()
      this.handleCancel()
    },
    async showModal(action, data) {
      var res = await lou.customUrlGet('gaji/instansi', false, true)
      var res1 = await lou.customUrlGet('gaji/golongan', false, true)
      // var res2 = await lou.customUrlGet('roletype', false, true)
      if (res) {
        this.datainstansi = res.data
      }
      if (res1) {
        this.datagolongan = res1.data
      }
      // if (res2) {
      //   this.dataroletype = res2.data
      // }
      this.editdata = this.$g.clone(data)
      this.inputdate = moment(this.editdata.tgl_lahir, 'YYYY-MM-DD')
      if (action !== 'Create') {
        // console.log("moment().add(4, 'hours').format('HH:mm')", moment().add(4, 'hours').format('HH:mm'))
        // console.log('this.editdata', this.editdata)
        this.input = this.editdata
        this.editshiftmode = false
      } else {
        this.resetForm()
      }
      this.visible = true
      this.action = action
    },
    handleCancel() {
      this.visible = false
      this.resetForm()
    },
    resetForm() {
      this.action = 'Create'
      this.editdata = []
      this.input = {
        instansi_id: '',
        nip: '',
        nik: '',
        nama: '',
        kelamin: '',
        tempat_lahir: '',
        tgl_lahir: moment().format('YYYY-MM-DD'),
        alamat: '',
        status_nikah: '',
        golongan_id: '',
      }
      this.inputdate = moment()

      this.datatable = []
      this.editshiftmode = false
      this.visible = false
      this.loading = false
      this.datenow = ''
    },
    onSearch(searchText) {
      this.dataSource = !searchText ? [] : ['Pagi', 'Sore', 'Damn']
    },
    handleChange(value) {
      // console.log(`selected ${value}`)
    },
    handleBlur() {
      // console.log('blur')
    },
    handleFocus() {
      // console.log('focus')
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    capt(word) {
      return lou.capitalize(word)
    },
  },
}
</script>

<style></style>
